module.exports = __webpack_public_path__ + "static/media/cross-error.5afee659.svg";